import { RocheUIImagePosition as r, RocheUIImageRatio as c } from "./roche-image.types.js";
const i = (e) => {
  const t = Object.values(c).includes(e) ? e : c.HD;
  if (t === c.ORIGINAL)
    return null;
  const [s, n] = t.split(":").map(parseFloat);
  return s / n;
}, u = (e, t, s, n) => {
  const a = i(s);
  let o = 0;
  return n ? o = n : a && (o = Math.round(t / a)), e.replace(/\$0/g, `${t}`).replace(/\$1/g, `${o}`);
}, R = (e) => e.includes("$0"), g = (e) => {
  var t;
  return ((t = Object.entries(c).find(([, s]) => s === e)) == null ? void 0 : t[0].toLowerCase()) || null;
}, I = (e) => Object.values(r).includes(e) ? e : r.CENTER, m = (e) => {
  if (!(!e || e === c.ORIGINAL))
    return e.replace(":", " / ");
};
export {
  u as createImageUrl,
  m as getCssAspectRatio,
  I as getPositionParsed,
  g as getRatioName,
  R as isImageServiceUrl
};
